/**
 * ItemGo Service Rescue — Pricing Engine
 *
 * Base price includes first 20 miles. Extra miles charged per mile.
 * Priority multipliers for urgent/emergency. Night and holiday surcharges.
 * All values in pence (GBP). VAT on (servicePrice + serviceFee).
 * Everything configurable from Firestore pluginConfigs/{serviceId}.
 */
export const DEFAULT_RESCUE_PRICING_CONFIG = {
    serviceFee: 599, // £5.99
    vatRate: 0.20, // 20%
    basePrice: 12000, // £120.00 — includes first 20 miles
    pricePerMile: 300, // £3.00 per mile beyond included
    includedMiles: 20,
    minDistance: 1,
    urgentMultiplier: 1.5,
    emergencyMultiplier: 2.5,
    nightSurcharge: 5000, // £50.00
    holidaySurcharge: 8000, // £80.00
};
export function calculateRescuePricing(input) {
    const config = input.config;
    const distance = Math.max(input.distanceMiles || 0, config.minDistance);
    const priority = input.priority || 'standard';
    const basePrice = config.basePrice;
    const includedMiles = config.includedMiles ?? 20;
    const extraMiles = Math.max(0, distance - includedMiles);
    const distanceCharge = Math.round(extraMiles * config.pricePerMile);
    let priorityMultiplier = 1;
    if (priority === 'urgent')
        priorityMultiplier = config.urgentMultiplier;
    if (priority === 'emergency')
        priorityMultiplier = config.emergencyMultiplier;
    let surcharge = 0;
    if (input.isNight)
        surcharge += config.nightSurcharge;
    if (input.isHoliday)
        surcharge += config.holidaySurcharge;
    const subtotal = basePrice + distanceCharge + surcharge;
    const servicePrice = Math.round(subtotal * priorityMultiplier);
    const serviceFee = config.serviceFee ?? 599;
    const vatRate = config.vatRate ?? 0.20;
    const vatAmount = Math.round((servicePrice + serviceFee) * vatRate);
    const customerTotal = servicePrice + serviceFee + vatAmount;
    return {
        basePrice,
        includedMiles,
        extraMiles,
        distanceCharge,
        priorityMultiplier,
        surcharge,
        servicePrice,
        serviceFee,
        vatAmount,
        customerTotal,
        formatted: {
            basePrice: formatPence(basePrice),
            distanceCharge: formatPence(distanceCharge),
            surcharge: formatPence(surcharge),
            servicePrice: formatPence(servicePrice),
            serviceFee: formatPence(serviceFee),
            vatAmount: formatPence(vatAmount),
            customerTotal: formatPence(customerTotal),
        },
    };
}
export function formatPence(pence) {
    return `£${(pence / 100).toFixed(2)}`;
}
//# sourceMappingURL=pricing.js.map